import * as React from "react";
import { canEditDocument, canDeleteDocument, canPublishDocument } from "../model/content-access";
import { NBSP } from "../utils/string";
import { IUserDetails } from "./with-auth-context";
import Button from "@material-ui/core/Button/Button";
import Delete from "@material-ui/icons/Delete";
import { LinkButton } from "./link-button";
import Edit from "@material-ui/icons/Edit";
import Publish from "@material-ui/icons/Publish";
import { AbstractDocument } from "../model/autogen/AbstractDocument";

export interface IDocumentActionListProps {
    editRoute?: string;
    user: IUserDetails;
    model: AbstractDocument;
    onDelete?: (e: any) => void;
    onPublishContent?: (e: any) => void;
}

export const DocumentActionList = (props: IDocumentActionListProps) => {
    const { editRoute, user, model, onDelete, onPublishContent } = props;
    return <div style={{float:'right', margin:'10px'}}>
        <>{canEditDocument(model, user) && editRoute && <><LinkButton color="primary" variant="contained" to={editRoute}><Edit />{NBSP}Edit</LinkButton></>}</>
        <>{canDeleteDocument(model, user) && onDelete && <>{NBSP}<Button color="secondary" variant="contained" onClick={onDelete}><Delete />{NBSP}Archive</Button></>}</>
        <>{!(model.isPublished == true) && onPublishContent && canPublishDocument(model, user) && <>{NBSP}<Button color="primary" variant="contained" onClick={onPublishContent}><Publish />{NBSP}Publish</Button></>}</>
    </div>;
}


// WEBPACK FOOTER //
// ./src/components/document-action-list.tsx